import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    FooterComponent
  ],
  declarations: [ FooterComponent]
})
export class CommonComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/common-components/common-components.module.ts